import React from "react";
import clsx from "clsx";
import { useState } from "react";
const Article = ({ input }) => {
  const [expand, setExpand] = useState(false);
  const thumbnails = input.pages.filter((el) => el.thumbnail);

  return (
    <article className='mb-md'>
      <div className='media'>
        <div
          className={clsx(
            "scroller-x bg-whiteSmoke",
            `len-${thumbnails.length}`
          )}>
          <div className='flex items-center'>
            {thumbnails.map((el, i) => (
              <figure key={i} className='flex-shrink-0 mr-xs'>
                <img
                  src={el.thumbnail?.source}
                  alt=''
                  className='w-auto'
                  loading='lazy'
                />
                {/* <pre>{JSON.stringify(el)}</pre> */}
              </figure>
            ))}
          </div>
        </div>
        <div className='absolute w-full h-full top-0 left-0 pointer-events-none'>
          <strong className='year tabnum py-sm px-xs'>{input.year}</strong>
        </div>
      </div>

      <div className='body p-sm'>
        <p>
          {input.text}
          {!expand && (
            <>
              {`... `}
              <button
                className='text-gray inline'
                onClick={() => setExpand(true)}>
                read more
              </button>
            </>
          )}
        </p>
        {expand && (
          <p className='pl-md'>
            {input.pages[0].extract}{" "}
            <a
              href={input.pages[0].content_urls.desktop.page}
              target='_blank'
              rel='noopener'>
              visite →
            </a>
          </p>
        )}

        {/* {!expand && (
          <div className='excerpt'>
            <p>
              {`${input.text}... `}
              <button className='text-gray' onClick={() => setExpand(true)}>
                read more
              </button>
            </p>
          </div>
        )}

        {expand && (
          <div className='content'>
            <p>{input.pages[0].extract}</p>
            <a
              href={input.pages[0].content_urls.desktop.page}
              target='_blank'
              rel='noopener'>
              visite →
            </a>
          </div>
        )} */}
      </div>
    </article>
  );
};

export default Article;
